import Button from "react-bootstrap/Button";
import Card from "react-bootstrap/Card";
function ReportCard(props) {
  const report = { ...props.report };
  console.log(report);
  return (
    <Card>
      <Card.Body className="inline-flex">
        <Card.Text>
          {report.CUSTOM_DATA ? report.CUSTOM_DATA.ProblemDescription : "None"}{" "}
          : {report.USER_CRASH_DATE}
        </Card.Text>
        <Button
          className="align-right"
          type="button"
          onClick={() => {
            props.onView(report._id);
          }}
        >
          View
        </Button>
        <Button
          type="delete"
          onClick={() => {
            props.onDelete(report._id);
          }}
        >
          Delete
        </Button>
      </Card.Body>
    </Card>
  );
}
export default ReportCard;
